export const URI = "Association";
export const isOne = (a) => a._tag === "One";
export const isMany = (a) => a._tag === "Many";
export const one = (value) => ({ _tag: "One", value });
export const many = (value) => ({ _tag: "Many", value });
export const targetOf = (r, v) => ({
    r,
    v,
});
export const evalAssoc = (assoc) => typeof assoc.value === "function" ? assoc.value() : assoc.value;
export const prValidated = (assoc) => evalAssoc(assoc).v;
export const prRelationships = (assoc) => evalAssoc(assoc).r;

